import { render, staticRenderFns } from "./add answers section.vue?vue&type=template&id=9d831f06"
import script from "./add answers section.vue?vue&type=script&lang=js"
export * from "./add answers section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports